import { stepIconClasses } from '@mui/material';
export const MuiStepper = {
    styleOverrides: {
        root: {},
        vertical: {
            height: 'fit-content',
        },
    },
};
export const MuiStepConnector = {
    styleOverrides: {
        root: ({ theme }) => ({
            marginLeft: '15px',
            '&.Mui-disabled > .MuiStepConnector-line': {
                borderColor: theme.palette.zinc[300],
            },
        }),
        line: ({ theme }) => ({
            variants: [
                {
                    props: { orientation: 'vertical' },
                    style: {
                        borderLeftStyle: 'solid',
                        borderRightStyle: 'solid',
                        borderLeftWidth: '1px',
                        borderRightWidth: '1px',
                        width: '2px',
                        borderRadius: '1px',
                        borderColor: theme.palette.primary.dark,
                        marginTop: '-14px',
                        marginBottom: '-16px',
                        minHeight: ' 53px',
                    },
                },
            ],
        }),
    },
};
export const MuiStepLabel = {
    styleOverrides: {
        iconContainer: {
            paddingRight: '1rem',
        },
    },
};
export const MuiStepIcon = {
    styleOverrides: {
        root: ({ theme }) => ({
            fontSize: theme.spacing(8),
            [`.${stepIconClasses.text}`]: {
                fontSize: theme.typography.helper.fontSize,
            },
            // TODO: to delete later
            // '&.Mui-active': {
            // 	color: theme.palette.primary.dark,
            // },
            [`&.${stepIconClasses.active}`]: {
                color: theme.palette.primary.dark,
            },
            '.Mui-disabled &': {
                color: theme.palette.text.translucent,
            },
        }),
    },
};
